<template>
  <div class="team">
    <template v-if="!noTeam">
      <div class="team_info">
        <h2 class="team_name">我的团队：{{ myTeam.name }}</h2>
        <!-- <p class="team_captain">队长：{{ myTeam.captainName }}</p> -->
        <!-- <p class="team_status">
              团队状态：
              <el-tag type="success" v-if="myTeam.status == 'RESOLVE'"
                >已通过</el-tag
              >
              <el-tag type="warning" v-if="myTeam.status == 'PENDING'"
                >审核中</el-tag
              >
              <el-tag type="danger" v-if="myTeam.status == 'REJECT'"
                >已拒绝</el-tag
              >
            </p> -->
        <!-- <p class="tiktok" v-if="classInfo.douyin">
          抖音绑定状态:
          <el-tag
            type="success"
            effect="dark"
            v-if="
              myTeam.douyinAccessTokenExpireDate &&
              verDate(myTeam.douyinAccessTokenExpireDate)
            "
            >已授权</el-tag
          >
          <el-tag
            type="warning"
            effect="dark"
            v-else-if="
              myTeam.douyinAccessTokenExpireDate &&
              !verDate(myTeam.douyinAccessTokenExpireDate)
            "
            >授权已过期</el-tag
          >
          <el-tag type="danger" effect="dark" v-else>未绑定</el-tag>
        </p> -->
        <p class="tiktok" v-if="classInfo.douyin">
          新媒体账号绑定状态:
          <el-tag
            type="success"
            effect="dark"
            v-if="
              myTeam.kuaishouRefreshTokenExpireDate &&
              verDate(myTeam.kuaishouRefreshTokenExpireDate)
            "
            >已授权</el-tag
          >
          <el-tag
            type="warning"
            effect="dark"
            v-else-if="
              myTeam.kuaishouRefreshTokenExpireDate &&
              !verDate(myTeam.kuaishouRefreshTokenExpireDate)
            "
            >授权已过期</el-tag
          >
          <el-tag type="danger" effect="dark" v-else>未绑定</el-tag>
        </p>

        <el-button
          type="danger"
          size="small"
          plain
          round
          style="float: right; margin-left: 10px"
          @click="handleDisBindingKuaishou"
          v-if="
            classInfo.douyin &&
            isCaptain &&
            myTeam.kuaishouRefreshTokenExpireDate
          "
          >解绑新媒体账号</el-button
        >
        <KuaishouAuth
          v-if="classInfo.douyin && isCaptain"
          :classId="$route.query.id"
          @onSuccess="getMyTeam"
          style="float: right; margin-left: 10px"
        />
        <!-- <el-button
          type="danger"
          size="small"
          plain
          round
          style="float: right; margin-left: 10px"
          @click="handleDisBinding"
          v-if="
            classInfo.douyin && isCaptain && myTeam.douyinAccessTokenExpireDate
          "
          >解绑抖音</el-button
        >
        <DyAuthorization
          v-if="classInfo.douyin && isCaptain"
          :classId="$route.query.id"
          @onSuccess="getMyTeam"
          style="float: right; margin-left: 10px"
        /> -->
        <!-- <el-button
              type="danger"
              size="small"
              style="float: right; margin-left: 10px"
              @click="dismissTeam"
              v-if="isCaptain && myTeam.status != 'RESOLVE'"
              >解散团队</el-button
            > -->
        <!-- <el-button
              type="primary"
              size="small"
              style="float: right"
              @click="showEdit = true"
              v-if="isCaptain"
              >修改团队名称</el-button
            > -->
      </div>
      <el-table class="team_list" :data="memberList" border>
        <el-table-column prop="avatar" label="头像" width="150" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.avatar"
              style="width: 44px; height: 44px"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="sno" label="学号" align="center">
        </el-table-column>
        <el-table-column prop="post" label="职位" align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="审核状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.status == 'RESOLVE'"
              type="success"
              effect="dark"
              >已通过</el-tag
            >
            <el-tag
              v-if="scope.row.status == 'PENDING'"
              type="warning"
              effect="dark"
              >审核中</el-tag
            >
            <el-tag
              v-if="scope.row.status == 'REJECT'"
              type="danger"
              effect="dark"
              >已拒绝</el-tag
            >
          </template>
        </el-table-column>

        <!-- <el-table-column prop="score" label="成绩" align="center">
          <template slot-scope="scope">
            {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
          </template>
        </el-table-column> -->
        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          v-if="isCaptain"
        >
          <template slot-scope="scope" v-if="scope.row.userId != myId">
            <el-button
              v-if="scope.row.status == 'PENDING'"
              @click.native.prevent="editRow(scope.row.teamUserId, 'RESOLVE')"
              type="text"
              size="small"
            >
              审核
            </el-button>
            <el-button
              v-if="scope.row.status == 'PENDING'"
              @click.native.prevent="editRow(scope.row.teamUserId, 'REJECT')"
              type="text"
              size="small"
            >
              拒绝
            </el-button>
            <el-button
              @click.native.prevent="
                deleteRow(scope.row.teamUserId, scope.row.nickName)
              "
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <!-- 空状态 -->
    <empty-status
      v-else
      desc="您还没加入团队，请先加入团队或创建团队"
      buttonText="创建团队"
      haveButton
      @btnClick="handleSetTeam"
    >
      <button class="btn" @click="activeName = '2'">加入团队</button>
    </empty-status>

    <el-dialog
      title="修改团队名称"
      :visible.sync="showEdit"
      width="30%"
      center
      v-if="!noTeam"
    >
      <el-input v-model="myTeam.name" placeholder="请输入团队名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showEdit = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleEditTeam"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  teamList,
  myTeam,
  memberList,
  verifyMember,
  delTeam,
  delMember,
  editTeam,
  cancelBinding,
  cancelBindingKuaishou,
} from "@/api/team";
import emptyStatus from "@/components/emptyStatus/index";
import { formatDate } from "@/utils/index";
import DyAuthorization from "@/components/dyAuthorization";
import KuaishouAuth from "@/components/kuaishouAuth";
export default {
  components: {
    emptyStatus,
    DyAuthorization,
    KuaishouAuth,
  },
  props: {
    classInfo: Object,
  },
  data() {
    return {
      isCaptain: false,
      activeName: "1",
      myTeam: {},
      noTeam: false,
      teamList: [],
      memberList: [],
      showEdit: false,
    };
  },
  created() {
    this.getList();
    this.getMyTeam();
    this.getMemberList();
  },
  computed: {
    myId() {
      return this.$store.state.myInfo.userId;
    },
    update() {
      return this.$store.state.update;
    },
  },
  watch: {
    update(val) {
      if (val) {
        this.getList();
        this.getMyTeam();
        this.getMemberList();
        this.$store.commit("SET_UPDATE", false);
      }
    },
  },
  methods: {
    // 团队列表
    getList() {
      this.$loading.show();
      teamList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.teamList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 我的团队
    getMyTeam() {
      myTeam({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.noTeam = res.data ? false : true;
          this.myTeam = res.data;
          if (res.data) this.isCaptain = this.myId == res.data.captainId;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 团队成员
    getMemberList() {
      memberList(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.memberList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 性别
    sexFormatter(row) {
      if (row.sex == 0) {
        return "未知";
      } else if (row.sex == 1) {
        return "男";
      } else {
        return "女";
      }
    },
    // 审核成员
    editRow(teamUserId, status) {
      this.$loading.show();
      verifyMember({ status, teamUserId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success(
            `${status == "RESOLVE" ? "已通过加入请求" : "已拒绝加入请求"}`
          );
          this.getMemberList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除成员
    deleteRow(teamUserId, nickName) {
      this.$confirm(`确定要将${nickName}从队伍中移除吗?`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delMember(teamUserId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getMemberList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 解散团队
    dismissTeam() {
      this.$confirm("确定要解散团队吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delTeam().then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("解散成功");
              this.getMyTeam();
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 申请加入
    handleJoin(teamId) {
      this.$router.push({
        path: "/classCourse/teams/teamOperate",
        query: {
          ...this.$route.query,
          teamId,
          type: 2,
        },
      });
    },
    // 导出
    onExport() {
      console.log(this.activeName);
    },
    // 创建团队
    handleSetTeam() {
      this.$router.push({
        path: "/classCourse/teams/teamOperate",
        query: {
          ...this.$route.query,
          type: 1,
        },
      });
    },
    handleEditTeam() {
      this.$confirm(`确定要修改吗?`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          editTeam(this.myTeam).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message.success("修改成功");
              this.showEdit = false;
              this.getMyTeam();
              this.getList();
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch(() => {});
    },
    verDate(date) {
      let now = new Date().getTime();
      let checkDate = new Date(date).getTime();
      return checkDate - now > 0 ? true : false;
    },
    // 解除绑定
    handleDisBinding() {
      this.$confirm(`解绑后将无法获取相关数据,确定要解绑当前抖音号吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          cancelBinding({ classId: this.$route.query.id }).then(
            ({ code, msg }) => {
              this.$loading.hide();
              if (code == 0) {
                this.$message.success("已解除绑定");
                this.getMyTeam();
              } else {
                this.$message.error(msg);
              }
            }
          );
        })
        .catch(() => {});
    },
    handleDisBindingKuaishou() {
      this.$confirm(`解绑后将无法获取相关数据,确定要解绑当前新媒体账号吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          cancelBindingKuaishou({ classId: this.$route.query.id }).then(
            ({ code, msg }) => {
              this.$loading.hide();
              if (code == 0) {
                this.$message.success("已解除绑定");
                this.getMyTeam();
              } else {
                this.$message.error(msg);
              }
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.team {
  position: relative;
  padding: 20px 33px;
  background-color: rgb(255, 255, 255);

  .export_btn {
    position: absolute;
    top: 20px;
    right: 33px;
    z-index: 999;
  }

  .team_info {
    margin-bottom: 10px;
    text-align: left;
    overflow: hidden;

    .team_name,
    .team_captain,
    .team_status,
    .tiktok {
      display: inline-block;
      margin-right: 20px;
      &.team_name {
        font-size: 18px;
      }
    }
  }

  ::v-deep .team_list {
    .is-leaf {
      color: #fff;
      background-color: #0088ff;
    }
  }

  .empty {
    position: relative !important;
    top: inherit;
    left: inherit;
    transform: inherit;
    padding: 30px 0;
  }
  .btn {
    margin-top: 40px;
    margin-left: 20px;
    width: 160px;
    height: 45px;
    color: #fff;
    background: #1976f5;
    font-size: 20px;
  }
  ::v-deep .tiktok-dialog {
    .el-dialog__body {
      text-align: center;
    }
    .tips {
      margin-bottom: 10px;
      color: #f56c6c;
    }
    #qrCode {
      img {
        display: inline-block !important;
      }
    }
  }
}
</style>
